/**
 * Détection d'appareil tactile (iPad/iPhone) pour le POS.
 *
 * Test canonique : un iPad se déguise en Mac dans son user-agent, mais répond
 * `maxTouchPoints = 5` là où un Mac mini répond `0`. On ne se fie PAS à
 * `pointer: coarse` : les minis ont des écrans clients tactiles branchés en
 * HDMI/USB, et on ne veut aucune ambiguïté sur le navigateur principal.
 *
 * ⚠️ CONTRAT : toute adaptation tactile du POS doit être conditionnée à cette
 * constante, afin que le comportement sur les Mac mini (clavier physique,
 * scan-d'abord, deux colonnes) reste STRICTEMENT celui d'aujourd'hui.
 * Évaluée une fois au chargement — un appareil ne change pas de nature en cours
 * de session.
 */
export const IS_TOUCH_DEVICE =
  typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1;
